import React, {useEffect} from 'react';
import {usePhaseState} from 'funnel-schedule/phase-context';
import SalesIndex from './join';

export default function (props) {
  return <SalesIndex ctaOverride="postApp" />;
}
